<template>
  <div class="scene-card">
    <div class="rounded-[12px] overflow-hidden scene-card__cover relative">
      <img :src="data.image_url" class="w-full h-full object-cover" @click="onDetail" />
      <div
        class="flex justify-between p-[12px] gap-[8px] button-groups mt-[8px] absolute bottom-0 left-0 w-full"
      >
        <a-button class="button detail-button" @click="onDetail">{{
          $t('cha-kan-xiang-qing-learn')
        }}</a-button>
        <a-button type="primary" class="button scene-button" @click="emit('create')">
          {{ $t('yong-ci-chang-jing-chuang-zuo') }}
        </a-button>
      </div>
    </div>
    <Text weight="regular" variant="16" class="text-center mt-[12px]">
      {{ data.name }}
    </Text>
  </div>
</template>

<script setup lang="ts">
import type { MockSceneDetails } from '@/api/interface/scene';
import { Text } from '@rendora/design/components/text';

const props = defineProps<{
  data: (typeof MockSceneDetails.recommended_data)[0];
  refresh: () => void;
}>();

const emit = defineEmits(['create']);

const onDetail = () => {
  // location.href = `/scene-details?look_name=${props.data.identity}`
  window.open(`/scene-details?look_name=${props.data.identity}`, '_blank');
};
</script>

<style lang="scss">
.scene-card {
  width: 282px;
  &__cover {
    height: 163px;
  }

  .button {
    flex: 1;
    border: 1px solid transparent;
  }
  .button-groups {
    display: none;
  }
  .detail-button {
    border-color: rgba(232, 234, 238, 1);
    &:hover {
      border-color: rgba(105, 98, 255, 1);
      color: rgba(105, 98, 255, 1);
    }
  }
  .scene-button {
    &:hover {
      background: #5650dc;
      border-color: #5650dc;
    }
  }
  &:hover {
    .button-groups {
      display: flex;
    }
  }
}

@media screen and (min-width: 1600px) and (max-width: 1919.98px) {
  .scene-card {
    width: calc(282px + (342px - 282px) * (100vw - 1600px) / 320);
  }
  .scene-card__cover {
    height: calc(163px + (198px - 163px) * (100vw - 1600px) / 320);
  }
}

@media screen and (min-width: 1920px) {
  .scene-card {
    width: 342px;
  }
  .scene-card__cover {
    height: 198px;
  }
}
</style>
